import { Translations } from "@/operator/@types/i18n";

export enum Namespace {
  Common = "common",
  MerchantManagement = "merchant_management",
}

export enum Language {
  EN = "en",
}

export enum Locale {
  EN_US = "en-US",
}

export interface TranslationInput {
  text: Translations | Translations[];
  prefix?: string;
  postfix?: string;
  interpolation?: { [key: string]: string | number };
  count?: number;
  ns?: Namespace;
  enableTooltip?: boolean;
}

export interface SimpleTranslationInput {
  text: Translations | Translations[];
}

export const defaultLanguage = Language.EN;

export const defaultLocale = Locale.EN_US;

export const defaultNamespace = Namespace.Common;

export const namespaces = Object.values(Namespace);

export const languages = Object.values(Language);
